const Data = [
  {
    id: 1,
    text: "John Smith",
    day: "Dec 12th at 2:30pm",
    completed: false,
    doctor: "Dr. Alice Walker",
  },
  {
    id: 2,
    text: "Emily Johnson",
    day: "Dec 13th at 1:30pm",
    completed: true,
    doctor: "Dr. Mary Brown",
  },
  {
    id: 3,
    text: "Michael Williams",
    day: "Dec 14th at 3:00pm",
    completed: false,
    doctor: "Dr. Laura White",
  },
  {
    id: 4,
    text: "Sarah Davis",
    day: "Dec 12th at 2:30pm",
    completed: false,
    doctor: "Dr. James Black",
  },
  {
    id: 5,
    text: "David Miller",
    day: "Dec 13th at 1:30pm",
    completed: true,
    doctor: "Dr. Olivia Davis",
  },
  {
    id: 6,
    text: "Olivia Wilson",
    day: "Dec 14th at 3:00pm",
    completed: false,
    doctor: "Dr. Laura White",
  },
];

export default Data;
